import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marks the calls that *establish* a session, so `errorInterceptor` does not read their 401 as a
 * session that ended.
 *
 * The two look alike from the outside — both are a 401 while a token sits in the store — because a
 * failed restore leaves the expired one there (see sessionGuard). Treating a wrong password as
 * expiry navigates away from `/login/test` mid-typing and takes the form with it.
 */
export const IS_LOGIN_ATTEMPT = new HttpContextToken(() => false);

/** Context for the calls above — pass as `{ context: isLoginAttempt() }`. */
export function isLoginAttempt(): HttpContext {
  return new HttpContext().set(IS_LOGIN_ATTEMPT, true);
}
